import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Load Montserrat locally 
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/700.css";


if (process.env.NODE_ENV === 'development') {
  try {
   
    const antd = require('antd');
    if (antd && antd.Table && Object.prototype.hasOwnProperty.call(antd.Table, 'defaultProps')) {
      try {
      
        delete antd.Table.defaultProps;
      } catch (e) {
       
      }
    }
  } catch (e) {
    // antd not installed or other error - ignore silently
  }
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Accessibility helper: ensure Ant Design Select internal search inputs have an accessible name
// This attaches title/placeholder attributes to inputs with class .ant-select-selection-search-input
// based on the closest Select element's aria-label or placeholder, or a sensible French default.
;(function ensureSelectSearchLabels() {
  if (typeof window === 'undefined' || !document || !MutationObserver) return;

  function labelInput(input) {
    if (!input || input.getAttribute('title') || input.getAttribute('placeholder')) return;
    // try to find a closest parent select wrapper to read aria-label/placeholder
    let el = input;
    let label = null;
    while (el && el !== document.body) {
      el = el.parentElement;
      if (!el) break;
      // Ant Design adds role="combobox"/aria-label on the trigger element; check for aria-label first
      if (el.hasAttribute('aria-label')) {
        label = el.getAttribute('aria-label');
        break;
      }
      // as fallback look for placeholder on the trigger
      if (el.hasAttribute('placeholder')) {
        label = el.getAttribute('placeholder');
        break;
      }
    }

    if (!label) label = 'Rechercher'; // sensible French default
    try {
      input.setAttribute('title', label);
      // placeholder helps some accessibility tools discover intent when the input is visible
      input.setAttribute('placeholder', label);
    } catch (e) {
      // ignore in case input is read-only or otherwise restricted
    }
  }

  function scanAndLabel(root) {
    root = root || document;
    const inputs = root.querySelectorAll('.ant-select-selection-search-input');
    inputs.forEach(labelInput);
  }

  // initial pass
  try { scanAndLabel(document); } catch (e) { /* ignore */ }

  // observe additions to the DOM so dynamically created Select inputs get labeled
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          try {
            if (node.nodeType === 1) scanAndLabel(node);
            // also check descendants of the added node
            if (node.querySelectorAll) scanAndLabel(node);
          } catch (e) {}
        });
      }
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
})();